import { useTranslation } from 'react-i18next';

export const useLanguage = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    // localStorage'a kaydet
    try {
      localStorage.setItem('smartpm-language', lng);
    } catch (error) {
      console.error('Error saving language to localStorage:', error);
    }
  };

  const currentLanguage = i18n.language;

  return {
    currentLanguage,
    changeLanguage,
    languages: ['tr', 'en'],
  };
};

